import { render, staticRenderFns } from "./veHqWeixiu.vue?vue&type=template&id=57f50378&scoped=true"
import script from "./veHqWeixiu.vue?vue&type=script&lang=js"
export * from "./veHqWeixiu.vue?vue&type=script&lang=js"
import style0 from "./veHqWeixiu.vue?vue&type=style&index=0&id=57f50378&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f50378",
  null
  
)

export default component.exports